import React from 'react';
import { Shield } from 'lucide-react';

const GizlilikPolitikasi = () => {
  return (
    <div className="min-h-screen">
      <div className="relative h-64 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 flex items-center">
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex items-center space-x-4">
            <div className="bg-orange-500 p-3 rounded-lg">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-white">Gizlilik Politikası</h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8">
          <div className="prose prose-lg max-w-none text-slate-700 space-y-6">
            <p>
              Turkish Menkul Değerler A.Ş. olarak kişisel verilerinizin güvenliği bizim için önemlidir. Bu gizlilik politikası, topladığımız bilgileri nasıl kullandığımızı açıklamaktadır.
            </p>
            <h2 className="text-2xl font-bold text-slate-900 mt-8">Toplanan Bilgiler</h2>
            <p>
              Web sitemizi ziyaret ettiğinizde, IP adresiniz, tarayıcı türü, ziyaret süresi gibi teknik bilgiler otomatik olarak toplanabilir.
            </p>
            <h2 className="text-2xl font-bold text-slate-900 mt-8">Bilgilerin Kullanımı</h2>
            <p>
              Toplanan bilgiler, hizmet kalitemizi artırmak, güvenliğinizi sağlamak ve yasal yükümlülüklerimizi yerine getirmek için kullanılır.
            </p>
            <h2 className="text-2xl font-bold text-slate-900 mt-8">Bilgi Güvenliği</h2>
            <p>
              Kişisel verilerinizi korumak için gerekli tüm teknik ve idari tedbirleri alırız.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GizlilikPolitikasi;